/* Arabic per-route titles + descriptions + not-found strings. Same shape and
 * conventions as meta-en.ts (read its header): «<الصفحة> · برَينوتس», homepage
 * is «برَينوتس · <الوصف>», About drops the suffix. All strings obey
 * docs/arabic-style-guide.md; meta.test.ts guards stem parity + copy rules. */
import type { MetaCopy } from './meta-en';

export const META_AR: MetaCopy = {
  pages: {
    '': {
      title: 'برَينوتس · محاضر الاجتماعات بالذكاء الاصطناعي',
      description:
        'برَينوتس مساحة عمل ذكية تحوّل اجتماعاتك ومحادثاتك إلى محاضر وملخصات وملاحظات منظمة بالعربية والإنجليزية، مع الحفاظ على خصوصية بياناتك وأمانها.',
    },
    privacy: {
      title: 'سياسة الخصوصية · برَينوتس',
      description:
        'نوضح كيف نجمع بياناتك ونستخدمها ونحميها، بما في ذلك بيانات حساب Google والتسجيلات الصوتية ومحاضر الاجتماعات.',
    },
    terms: {
      title: 'شروط الخدمة · برَينوتس',
      description:
        'الشروط التي تنظم استخدامك لبرَينوتس، بما في ذلك الباقات والمدفوعات والاسترداد والاستخدام المقبول.',
    },
    subprocessors: {
      title: 'مزودو الخدمات · برَينوتس',
      description:
        'الجهات الخارجية التي يعتمد عليها برَينوتس لتقديم الخدمة، والبيانات التي تعالجها كل منها.',
    },
    about: {
      title: 'عن برَينوتس',
      description:
        'قصة برَينوتس، مساحة عمل بالذكاء الاصطناعي لمحاضر الاجتماعات وتفريغها وتلخيصها، للمتحدثين بالعربية والإنجليزية، من تطوير شركة سعودية.',
    },
    trust: {
      title: 'الثقة والأمان · برَينوتس',
      description:
        'نوضح كيف يحمي برَينوتس بياناتك: حفظ البيانات داخل المملكة، وتشفيرها أثناء النقل والتخزين، وذكاء اصطناعي لا يتدرب على محتواك.',
    },
  },
  notFound: {
    title: 'الصفحة غير موجودة · برَينوتس',
    heading: 'تعذر العثور على هذه الصفحة',
    body: 'عذرًا، الصفحة التي تبحث عنها غير موجودة. يرجى التحقق من الرابط أو العودة إلى الصفحة الرئيسية.',
    home: 'العودة إلى الرئيسية',
    goBack: 'رجوع',
  },
};
